import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import Logo from '../components/Logo';

const NotFound: React.FC = () => {
  return (
    <>
      <SEO title="Page Not Found" description="The page you are looking for does not exist." />
      <div className="min-h-[70vh] flex items-center justify-center bg-cream-50 relative overflow-hidden">
        <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 bg-gold-100 rounded-full opacity-20 blur-3xl"></div>
        <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-96 h-96 bg-maroon-100 rounded-full opacity-20 blur-3xl"></div>

        <div className="text-center relative z-10 px-4 flex flex-col items-center">
          <div className="mb-6 scale-150">
            <Logo color="dark" />
          </div>
          <h1 className="text-9xl font-serif font-bold text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-gold-600 mb-4">404</h1>
          <h2 className="text-3xl font-serif font-bold text-maroon-900 mb-6">Page Not Found</h2>
          <p className="text-gray-600 text-lg mb-8 max-w-md mx-auto">
            Oops! It looks like you've wandered into an undecorated corner of our site. Let's get you back to the celebration.
          </p>
          <Link to="/" className="inline-block bg-maroon-900 text-white font-bold py-4 px-10 rounded-sm hover:bg-maroon-800 transition-all shadow-lg uppercase tracking-widest text-sm">
            Back to Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;